module.exports = __webpack_public_path__ + "img/partner_bg.a47c5259.png";